import { useMemo } from 'react';

import { NameAndCreateDateFormatter, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';
import { defaultColumn, defaultActionsColumn, deleteAction, editAction, toggleFormatter, defaultColumnId } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('key', 'Key', info => <TruncateWithTooltipFormatter info={info} />),
    defaultColumn('type'),
    defaultColumn('private', 'Private', toggleFormatter, { initialSize: 'w-18', enableColumnResize: false }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
